import { render, staticRenderFns } from "./Detalle-caja.vue?vue&type=template&id=3443eeac"
import script from "./Detalle-caja.vue?vue&type=script&lang=js"
export * from "./Detalle-caja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports